import React , { useState , useEffect , useCallback } from 'react';

import { getMediasPageAction, mediaTypeToApiType } from '../../../actions/mediasActions';
import Modale from '../../partials/Modale';
import MediaCard from '../medias/MediaCard';

import './medias.scss';

const PAGE_LIMIT = 24;

export default function SelectMedia(props) {
  const { displaySelectMedia , setDisplaySelectMedia , dispatch , isMulti, companyId , mediaType, selectedMediaList , handleChange } = props;

  const [ mediaList , setMediaList ] = useState([]);
  const [ search , setSearch ] = useState('');
  const [ debouncedSearch , setDebouncedSearch ] = useState('');
  const [ selectedList , setSelectedList ] = useState([]);
  const [ page , setPage ] = useState(1);
  const [ total , setTotal ] = useState(0);
  const [ loading , setLoading ] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (selectedMediaList) {
      setSelectedList(selectedMediaList);
    }
  }, [selectedMediaList]);

  const fetchMedias = useCallback(async () => {
    if (!displaySelectMedia || !companyId) {
      return;
    }

    setLoading(true);
    try {
      const result = await getMediasPageAction(dispatch, {
        companyId,
        type: mediaTypeToApiType(mediaType),
        search: debouncedSearch,
        page,
        limit: PAGE_LIMIT
      });
      setMediaList(result.files);
      setTotal(result.total);
    } finally {
      setLoading(false);
    }
  }, [displaySelectMedia, companyId, mediaType, debouncedSearch, page, dispatch]);

  useEffect(() => {
    if (displaySelectMedia) {
      setPage(1);
    }
  }, [debouncedSearch, mediaType, displaySelectMedia]);

  useEffect(() => {
    if (!displaySelectMedia) {
      setSearch('');
      setDebouncedSearch('');
    }
  }, [displaySelectMedia]);

  useEffect(() => {
    fetchMedias();
  }, [fetchMedias]);

  function selectMedias(media) {
    var list = [...selectedList]
    var found = selectedList.find(item => item === media._id);
    if (found) {
      list = list.filter(item => item !== media._id);
    } else {
      list.push(media._id);
    }
    if (!isMulti) {
      list = [media._id]
    }
    setSelectedList(list);
  };

  function validImg() {
    setDisplaySelectMedia(false);
    handleChange(selectedList)
  }

  const totalPages = Math.max(1, Math.ceil(total / PAGE_LIMIT));

  function renderMediaList() {
    if (loading && !mediaList.length) {
      return <p>Chargement…</p>;
    }

    if (!mediaList.length) {
      return <p>Aucun média trouvé.</p>;
    }

    return (
      <>
        {mediaList.filter(m => selectedList?.find(s => s === m._id)).map((media, i) => (
          <div
            className="select-card"
            key={'selected-' + media._id}
            onClick={() => selectMedias(media)}
          >
            <MediaCard media={media} isOnModale={true} selectedList={selectedList} dispatch={dispatch}/>
          </div>
        ))}
        {mediaList.filter(m => !selectedList?.find(s => s === m._id)).map((media) => (
          <div
            className="select-card"
            key={media._id}
            onClick={() => selectMedias(media)}
          >
            <MediaCard media={media} isOnModale={true} selectedList={selectedList} dispatch={dispatch}/>
          </div>
        ))}
      </>
    );
  }

  if (!displaySelectMedia) {
    return null;
  }

  return (
    <Modale
      modaleIsOpen={displaySelectMedia}
      modaleToggle={setDisplaySelectMedia}
      className={"select-media-modale"}
      >
      <>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Recherche"
          />

        <div className="media-list select">
          {renderMediaList()}
        </div>

        {totalPages > 1 &&
          <div className="btn-container" style={{ justifyContent: 'center', gap: 12 }}>
            <button
              type="button"
              className="btn grey"
              disabled={page <= 1 || loading}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Précédent
            </button>
            <span>{page} / {totalPages} ({total} médias)</span>
            <button
              type="button"
              className="btn grey"
              disabled={page >= totalPages || loading}
              onClick={() => setPage((p) => p + 1)}
            >
              Suivant
            </button>
          </div>
        }
        
        <div className="btn-container">
          <button
            type={'button'}
            onClick={() => validImg()}
            className={`btn success`}
            >
            Valider
          </button>
        </div> 

      </>
    </Modale>
  )
}
